export default {
  timestamp: 0,
  wind_desc: 1,
  avg: 2,
  lull: 3,
  gust: 4,
  dir: 5,
  dir_text: 6,
  atemp: 7,
  wtemp: 8,
  wave_height: 9,
  wave_period: 10,
  pres: 11,
  utc_timestamp: 12,
  status_id: 13,
  water_level: 14,
  humidity: 15,
  surface_temp: 17,
  water_skin_temp: 18,
  wet_bulb_globe_temp: 20
}